import React, { PropsWithChildren } from "react";

import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  type DndContextProps,
} from "@dnd-kit/core";
import {
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
  SortableContextProps,
} from "@dnd-kit/sortable";

interface VerticalDragAndDropListContextProps {
  onDragEnd: DndContextProps["onDragEnd"];
}

const VerticalDragAndDropListContext = ({
  children,
  onDragEnd,
}: PropsWithChildren<VerticalDragAndDropListContextProps>) => {
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );
  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={onDragEnd}
    >
      {children}
    </DndContext>
  );
};

interface VerticalDragAndDropListSortableContextProps {
  items: SortableContextProps["items"];
}

const VerticalDragAndDropListSortableContext = ({
  items,
  children,
}: PropsWithChildren<VerticalDragAndDropListSortableContextProps>) => {
  return (
    <SortableContext items={items} strategy={verticalListSortingStrategy}>
      {children}
    </SortableContext>
  );
};

export const VerticalDragAndDropList = {
  DndContext: VerticalDragAndDropListContext,
  SortableContext: VerticalDragAndDropListSortableContext,
};
